import React from "react";
import { TextField } from "@mui/material";
import GroupAllUsers from "../FieldTags/GroupAllUsers";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";

const newPlan = window.location.pathname === "/xplans/new";

const Title = ({ title, handleChange, xplans }) => {
    return (
        <div id="title" className="planField">
            <GroupAllUsers />
            <TextField
                name="title"
                label={xplanLabels.title}
                InputLabelProps={{ shrink: true }}
                type="text"
                required={true}
                value={title === null ? "" : title}
                onChange={(e) => handleChange("title", e.target.value)}
                className="fullLength"
                variant="standard"
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"title"} />}
        </div>
    );
};

export default Title;